'use client';

import { c as _c } from "react/compiler-runtime";
import type { TFunction } from 'i18next';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { IntlBlock } from '@sola/ark-core/atoms/intl/Intl.tsx';
import { LinkStyle } from '@sola/ark-core/atoms/link-style/link-style.tsx';
import { Link } from '@sola/ark-core/atoms/link/link.tsx';
import type { PageAlertConfig } from '../../types/page-alerts.ts';
import { usePageAlert } from '../page-alert/page-alert-provider.tsx';
import { useTransitionDepartureAlert } from './departure-alert-transition.logic.ts';
type TransitionAlertData = {
  childName?: string;
  count: number;
};
const getTransitionPageAlert = ({
  id,
  alertData,
  t
}: {
  id: string;
  alertData: TransitionAlertData;
  t: TFunction<'my', undefined>;
}): PageAlertConfig => {
  let titleKey = 'my:sponsorshipRelationship.departures.alert.transition.fallbackTitle';
  let messageKey = 'my:sponsorshipRelationship.departures.alert.transition.fallbackMessage';
  if (alertData.childName) {
    titleKey = 'my:sponsorshipRelationship.departures.alert.transition.title';
    messageKey = 'my:sponsorshipRelationship.departures.alert.transition.message';
  } else if (alertData.count > 1) {
    titleKey = 'my:sponsorshipRelationship.departures.alert.transition.multipleTitle';
    messageKey = 'my:sponsorshipRelationship.departures.alert.transition.multipleMessage';
  }
  return {
    id,
    priority: 100,
    variant: 'negative',
    title: t(titleKey, {
      childName: alertData.childName
    }),
    message: <IntlBlock i18nKey={messageKey} values={{
      childName: alertData.childName
    }} components={{
      phoneLink: <LinkStyle purpose="neutral" weightOverride="light" inline noPadding>
              <Link href={`tel:${t('core:contact.phonePrimary')}`} target="_self">
                {t('core:contact.phonePrimary')}
              </Link>
            </LinkStyle>
    }} />
  };
};
export const DepartureAlertTransition: React.FC<{
  globalId?: string;
}> = t0 => {
  const $ = _c(5);
  const {
    globalId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["core", "my"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const alertData = useTransitionDepartureAlert(globalId);
  let t2;
  bb0: {
    if (!alertData) {
      t2 = undefined;
      break bb0;
    }
    const t3 = globalId ? `transition-departure-${globalId}` : "transition-departure";
    let t4;
    if ($[1] !== alertData || $[2] !== t || $[3] !== t3) {
      t4 = getTransitionPageAlert({
        id: t3,
        alertData,
        t
      });
      $[1] = alertData;
      $[2] = t;
      $[3] = t3;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    t2 = t4;
  }
  const pageAlert = t2;
  usePageAlert(pageAlert);
  return null;
};